var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3278 9.24672L10.2074 16.3671C8.25479 18.3197 5.08896 18.3197 3.13634 16.3671C1.18372 14.4145 1.18372 11.2487 3.13634 9.29605L9.97171 2.46069C11.2735 1.15894 13.384 1.15894 14.6858 2.46069C15.9875 3.76243 15.9875 5.87298 14.6858 7.17473L7.86135 13.9991C7.21048 14.65 6.1552 14.65 5.50433 13.9991C4.85345 13.3483 4.85345 12.293 5.50433 11.6421L11.7258 5.42067",
    stroke: "#11C0F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/Attachment.86bfc67aead172589e7e20a91957e30d.svg";
export { ForwardRef as ReactComponent };